import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";

import logger from "redux-logger";

//Reducer
import reducers from "./reducers";
import homeReducers from "./redux/reducers/Projects";

const store = configureStore({
  reducer: reducers,
  homeReducer: homeReducers,
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
    logger,
  ],
});

const persistor = persistStore(store);

if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept("./redux/reducers/Projects", () => {
    const newReducers = require("./redux/reducers/Projects").default;
    store.replaceReducer(newReducers);
  });
}

export { store, persistor };
